import { Trans } from "../utils/i18n";
import Cookies from "js-cookie";
import React from "react";
import {validateVinRegEx} from "../Shared/FormField";

export const queueDetailConfigPyramid = {
    "sizes": {
        "forth": 3,
        "third": 4,
        "half": 6,
        "full": 12
    },
    "heading": <Trans i18nKey="orderEntry.basicData">Basic data</Trans>,
    "groups": [
        {
            "heading": <Trans i18nKey="orderEntry.orderInformation.heading">Order Information</Trans>,
            // "description": <Trans i18nKey="orderEntry.vin.description">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</Trans>,
            "fields": [
                {
                    "name": "ticketnumber",
                    "label": <Trans i18nKey="orderEntry.ticketnumber.label">Ticketnumber</Trans>,
                    "size": "half",
                    "required": true
                },
                {
                    "size": "full",
                    "component": "metapicker",
                    "key": "spareparts",
                    "name": "spareparts",
                    "label": <Trans i18nKey="orderEntry.spareparts.label">Spare parts</Trans>,
                    "required": true,
                    "type": "metapicker"
                },
                {
                    "name": "trackingcode",
                    "label": <Trans i18nKey="orderEntry.trackingcode.label">Tracking code</Trans>,
                    "size": "full",
                    "type": "text",
                },
                {
                    "name": "expectedArrival",
                    "label": <Trans i18nKey="orderEntry.expectedArrival.label">Expected arrival</Trans>,
                    "size": "full",
                    "type": "datetimepicker",
                    "preventWeekends": false,
                },
            ]
        },
    ],
}
